import { useState, KeyboardEvent, useId, FocusEvent } from 'react';
import { ErrorList, ListOfErrors } from '../forms';
import { Label } from './label';
import { Input } from './input';
import { input } from '@testing-library/user-event/dist/cjs/event/input.js';

const TagsInput: React.FC = () => {
  const [tags, setTags] = useState<string[]>([]);

  const addTag = (tag: string) => {
    if (tag && !tags.includes(tag)) { // Prevent duplicate tags
      setTags([...tags, tag]);
    }
  };

  const removeTag = (index: number) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const keysToAddTag = [",", ";", "Enter"]; // Array of keys that will trigger adding a tag
    if (keysToAddTag.includes(event.key)) {
      event.preventDefault();
      const target = event.target as HTMLInputElement;
      const newTag = target.value.trim().replace(/[,;]$/, ''); // Remove comma or semicolon at the end if any
      if (newTag) {
        addTag(newTag);
        target.value = '';
      }
      target.value = '';
    }
  };

  return (
    <div className="">
      <div className="flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <div key={index} className="flex items-center bg-background px-3 py-1 rounded-full">
            {tag}
            <button className="ml-2" onClick={() => removeTag(index)}>×</button>
          </div>
        ))}
      </div>
      <input
        type="text"
        onKeyDown={handleKeyDown}
        className="flex h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid]:border-input-invalid"
        placeholder="Add a tag"
      />
    </div>
  );
}

export function TagsInputField({
	labelProps,
	inputProps,
	errors,
	className,
}: {
	labelProps: React.LabelHTMLAttributes<HTMLLabelElement>
	inputProps: React.InputHTMLAttributes<HTMLInputElement>
	errors?: ListOfErrors
	className?: string
}) {


    var startingTags: string[] = []
    if (typeof inputProps.defaultValue !== "undefined") {
        if (Array.isArray(inputProps.defaultValue)) {
          startingTags = inputProps.defaultValue as string[];
          //inputProps.defaultValue.map((tag: any) => addTag(tag?.toString()));
        } else {
          startingTags = inputProps.defaultValue.toString().split(",");
          //inputProps.defaultValue.toString().split(",").map((tempTag: string) => addTag(tempTag));
        }
        delete inputProps.defaultValue;
    }

    const [tags, setTags] = useState<string[]>(startingTags);

    const addTag = (tag: string) => {
      if (tag && !tags.includes(tag)) { // Prevent duplicate tags
        setTags([...tags, tag]);
      }
    };
  


    const removeTag = (index: number) => {
      setTags(tags.filter((_, i) => i !== index));
    };
  
    const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
      const target = event.target as HTMLInputElement;
      const newTag = target.value.trim().replace(/[,;]$/, ''); // Remove comma or semicolon at the end if any
      if (newTag) {
        addTag(newTag);
        target.value = '';
      }
      target.value = '';
    }

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      const keysToAddTag = [",", ";", "Enter"]; // Array of keys that will trigger adding a tag
      if (keysToAddTag.includes(event.key)) {
        event.preventDefault();
        const target = event.target as HTMLInputElement;
        const newTag = target.value.trim().replace(/[,;]$/, '').toLowerCase(); // Remove comma or semicolon at the end if any
        if (newTag) {
          addTag(newTag);
          target.value = '';
        }
        target.value = '';
      }
    };
	const fallbackId = useId()
	const id = inputProps.id ?? fallbackId
	const errorId = errors?.length ? `${id}-error` : undefined
	return (
		<div className={className}>
			<Label htmlFor={id} {...labelProps} />
            <Input id={id} 
                {...inputProps}
                type='hidden'
                readOnly={true}
                value={tags.join(',')}
                            />
            <Input 
                    {...inputProps}
                    name={`${inputProps.name}_tag`}
                    id={`${id}_tag`}
                    aria-invalid={errorId ? true : undefined}
                    aria-describedby={errorId}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    placeholder="pvp, pvm, summoner, warrior, etc"
            />

            <div className="flex flex-wrap gap-1 mt-2">
                {tags.map((tag, index) => (
                <div key={index} className="flex items-center bg-background px-3 py-1 rounded-full">
                    {tag}
                    <button className="ml-2" onClick={(event) => {
                      event.preventDefault();
                      removeTag(index)}
                      }>×</button>
                </div>
                ))}
            </div>
				{errorId ? 			<div className="min-h-[32px] px-4 pb-3 pt-1">
<ErrorList id={errorId} errors={errors} /></div> : null}
			
		</div>
	)
}

export default TagsInput;
